<!-- 作业描述 -->
<template>
  <div
    :class="{
      'mobile-homework-desc': isMobile,
      'homework-desc': !isMobile,
    }"
  >
    <div class="desc-wrap">
      <div class="work-info-wrap">
        <p class="title">
          {{ workInfo.homework_name }}
        </p>
        <p v-if="!isClockIn" class="desc-item mg-b-12">
          <span class="sub-title">考试时间：</span>
          <span v-if="workInfo.work_end_time" class="cont-text"
            >限制{{
              moment(workInfo.work_end_time * 1000).format(
                "YYYY-MM-DD HH:mm:ss"
              )
            }}</span
          >
          <span v-else class="cont-text">不限时</span>
        </p>
        <p class="desc-item mg-b-24">
          <span class="sub-title">试题数量：</span>
          <span class="cont-text">{{ questionList.length }} 道</span>
        </p>
        <div class="mg-b-24 instructions">
          <p class="sub-title mg-b-8">考前须知：</p>
          <div class="cont-text" v-html="workInfo.homework_content"></div>
        </div>
        <div class="precautions">
          <p class="sub-title mg-b-8">注意事项：</p>
          <div class="cont-text">
            <!-- eslint-disable-next-line prettier/prettier -->
          <p>1、因故退出考试界面，系统将为你保留答题记录,请在考试时长内返回继续答题;
            </p>
            <p>2、超过考试时长，将为你自动交卷</p>
          </div>
        </div>
      </div>
      <div class="btn-wrap">
        <button
          v-preventReClick
          class="start-answer-btn"
          @click="handleStartAnswer"
        >
          开始答题
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
export default {
  props: {
    isClockIn: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      moment,
    };
  },
  computed: {
    ...mapState("defaultHomework", [
      "workInfo",
      "taskId",
      "questionList",
      "isMobile",
      "activeIndex",
    ]),
    ...mapGetters("defaultHomework", ["questionPids"]),
  },
  methods: {
    ...mapActions("defaultHomework", ["apiGetQuestionInfo"]),
    ...mapMutations("defaultHomework", ["setStartAnswer"]),
    handleStartAnswer() {
      if (this.questionList?.length === 0) return;
      let question_ids = this.questionPids.join(",");
      this.apiGetQuestionInfo({
        work_id: this.workInfo.id,
        task_id: this.taskId,
        question_ids,
      });
      this.setStartAnswer(true);
    },
  },
};
</script>

<style lang="scss" scoped>
.homework-desc {
  background: #ffffff;
  padding-top: 50px;
  padding-bottom: 140px;
  .desc-wrap {
    width: 427px;
    margin: 0 auto;
  }
  .title {
    font-weight: 500;
    font-size: 24px;
    color: #0d1400;
    line-height: 28px;
    margin-bottom: 31px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .sub-title {
    font-weight: 400;
    font-size: 16px;
    color: #4e5969;
    line-height: 26px;
  }
  .cont-text {
    white-space: pre-wrap;
    font-weight: 500;
    font-size: 16px;
    color: #1d2129;
    line-height: 26px;
  }
  .start-answer-btn {
    width: 180px;
    height: 40px;
    background: #386bff;
    border-radius: 20px;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 160px auto 0;
  }
  .mg-b-8 {
    margin-bottom: 8px;
  }
  .mg-b-12 {
    margin-bottom: 12px;
  }
  .mg-b-24 {
    margin-bottom: 24px;
  }
}

// 移动端样式
.mobile-homework-desc {
  padding-bottom: 3rem;
  background: #f7f8fa;
  .work-info-wrap {
    width: 9.15rem;
    margin: 0 auto;
    background: #ffffff;
    border-radius: 0.32rem;
    padding: 0.8rem 0.32rem 0.8rem;
    .title {
      font-weight: 500;
      font-size: 0.64rem;
      color: #1d2129;
      line-height: 0.88rem;
      text-align: center;
      margin-bottom: 0.32rem;
    }
    .desc-item {
      display: flex;
      align-items: center;
      margin-bottom: 0.32rem;
    }
    .sub-title {
      font-weight: 400;
      font-size: 0.43rem;
      color: #4e5969;
      line-height: 0.69rem;
    }
    .cont-text {
      font-weight: 500;
      font-size: 0.43rem;
      color: #1d2129;
      line-height: 0.69rem;
      white-space: pre-wrap;
    }
  }

  .btn-wrap {
    background: #f7f8fa;
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-bottom: 0.99rem;
    .start-answer-btn {
      width: 9.36rem;
      height: 1.07rem;
      background: #386bff;
      border-radius: 0.53rem;
      font-weight: 500;
      font-size: 0.43rem;
      color: #ffffff;
      line-height: 0.59rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
    }
  }

  .instructions,
  .precautions {
    .sub-title {
      margin-bottom: 0.21rem;
      margin-top: 0.16rem;
    }
  }
  .precautions {
    margin-top: 0.64rem;
  }
}
</style>
